module.exports = __webpack_public_path__ + "img/open-eye.5ba8e6ac.svg";